/***
 * 公用全局方法
 */
import { checkWord } from "@/api/smsSend";
// 奖品类型
const prizeTypeList = [
  { value: 1, label: '优惠券' },
  { value: 2, label: '京豆' },
  { value: 3, label: '实物' },
  { value: 4, label: '店铺积分' },
  { value: 5, label: '京东E卡' },
  { value: 6, label: '爱奇艺会员' },
  { value: 7, label: '京东PLUS会员' },
	{ value: 8, label: '现金红包' },
	{ value: 9, label: '谢谢参与' },
  { value: 10, label: '礼品卡' },
  { value: 12, label: '专享价' },
  { value: 13, label: '令牌' },
  { value: 14, label: '实物（随单发）' },
];
const activityTypeList = [
  {
    value: "",
    label: "-",
  },
  {
    value: 1,
    label: "日历签到",
  },
  {
    value: 3,
    label: "每日限时抢",
  },
  {
    value: 4,
    label: "关注店铺有礼",
  },
  {
    value: 5,
    label: "邀请开卡有礼",
  },
  {
    value: 6,
    label: "邀请关注有礼",
  },
  {
    value: 7,
    label: "完善信息有礼",
  },
  {
    value: 8,
    label: "幸运抽奖",
  },
  {
    value: 9,
    label: "积分兑换实物",
  },
  {
    value: 10,
    label: "积分兑换优惠券",
  },
  {
    value: 13,
    label: "开卡礼包",
  },
  {
    value: 14,
    label: "店铺礼包",
  },
  {
    value: 15,
    label: "店铺礼包（千人千面）",
  },
  {
    value: 16,
    label: "下单有礼",
  },
  {
    value: 17,
    label: "首单专享礼",
  },
  {
    value: 18,
    label: "复购有礼",
  },
  {
    value: 19,
    label: "下单抽奖",
  },
  {
    value: 20,
    label: "评价有礼",
  },
  {
    value: 21,
    label: "裂变神券",
  },
  
  {
    value: 22,
    label: "天降红包雨",
  },
  {
    value: 23,
    label: "欢乐娃娃机",
  },
  {
    value: 24,
    label: "大家来找茬",
  },
  {
    value: 25,
    label: "智能活动海报",
  },
  {
    value: 26,
    label: "刮刮乐",
  },
  {
    value: 27,
    label: "预售有礼",
  },
  {
    value: 28,
    label: "预售抽奖",
  },
  {
    value: 29,
    label: "积分兑换京豆",
  },
  {
    value: 30,
    label: "积分兑换E卡",
  },
  {
    value: 31,
    label: "超级裂变券",
  },
  {
    value: 32,
    label: "会员卡片",
  },
  {
    value: 33,
    label: "0元试用",
  },
  {
    value: 34,
    label: "加购有礼",
  },
  {
    value: 35,
    label: "积分确权活动",
  },
  {
    value: 36,
    label: "打榜有礼",
  },
  {
    value: 37,
    label: "派样回购礼",
  },
  {
    value: 38,
    label: "积分兑换红包",
  },
  {
    value: 39,
    label: "生日有礼",
  },
  {
    value: 40,
    label: "专属赠品礼",
  },
  {
    value: 41,
    label: "晒单有礼",
  },
  {
    value: 42,
    label: "派样回购礼（随单发",
  },
  {
    value: 43,
    label: "N元锁权",
  },
  {
    value: 44,
    label: "会员升级礼",
  },
  {
    value: 46,
    label: "满额有礼",
  },
  {
    value: 45,
    label: "锁权有礼",
  },
  {
    value: 47,
    label: "调查问卷",
  },
  {
    value: 48,
    label: "定时开奖",
  },
  {
    value: 50,
    label: "情书贺卡",
  },
  {
    value: 51,
    label: "0元试用",
  },
  {
    value: 52,
    label: "试用回购礼",
  },
  {
    value: 53,
    label: "购物打卡",
  },
  {
    value: 62,
    label: "集卡有礼",
  },
  {
    value: 63,
    label: "BI店铺礼包",
  },
  {
    value: 64,
    label: "组队瓜分奖品",
  },
  {
    value: 65,
    label: "粉丝打卡",
  },
  {
    value: 66,
    label: "入会有礼",
  },
  {
    value: 67,
    label: "销售打榜",
  },
   {
    value: 68,
    label: "会员成长计划",
  },
  {
   value: 69,
   label: "拼团砍价",
 },
  {
   value: 70,
   label: "积分竞拍",
  },
  { label: "趣味游戏", value: 71 },
  { label: "关注礼包", value: 74 },
  { label: "加购礼包", value: 75 },
  { label: "时光许愿池", value: 76 },
  {
    value: 77,
    label: "购物车锦鲤",
  },
  {
    value: 78,
    label: "打包一口价",
  },
  {
    value: 79,
    label: "盖楼有礼",
  },
  {
    value: 80,
    label: "小红书晒单礼",
  },
  {
    value: 81,
    label: "集分冲榜",
  },
  {
    value: 82,
    label: "粉丝集分应援",
  },
  {
    value: 83,
    label: "晒图pk",
  },
  {
    value: 84,
    label: "日历打卡",
  },
  {
    value: 85,
    label: "百变趣答",
  },
  {
    value: 86,
    label: "AI趣味答题",
  },
  {
    value: 87,
    label: "答题导购",
  },
  {
    value: 89,
    label: "积分兑换优惠券",
  },
]
export default {
  install(Vue) {
    // 短链接重复判断
    Vue.prototype.shopLinkCheck = function(e, link = "") {
      setTimeout(() => {
        const preData = e.target.value + "!#123-"
        if (preData.indexOf("#自定义短链接#") != -1) {
          this.$message.error("短信文案中包含#自定义短链接#，请使用辅助工具插入短网址！")
        }
        setTimeout(() => {
          const nextData = preData + e.target.value
          if(preData === "!#123-") {
            if(nextData.indexOf("3.cn/") != -1) {
              // e.target.value = preData.substring(0, preData.length - 6)
              this.$message.error("请勿复制或者重复使用短链接")
            }
            return
          }
          let arr = []
          arr = nextData.split(preData)
          const temp = arr[arr.length - 1]; // 数据处理获取复制内容
          const newArr = temp.split(preData.substring(0, preData.length - 6))
          const two = newArr.every((item) => {
            return item == "" 
          })
          if(two && temp.indexOf("3.cn/") != -1) {
            this.$message.error("请勿复制或者重复使用短链接")
            // e.target.value = preData.substring(0, preData.length - 6)
            return
          }
          const copyData = newArr[newArr.length - 1]
          // 判断重复短链接
          // if(preData.indexOf("3.cn/") != -1 && copyData.indexOf("3.cn/") != -1 && copyData.indexOf(link) != -1) {
          //   e.target.value = preData
          //   this.$message.error("请勿复制或者重复使用短链接")
          // }

          // 判断复制存在3.cn/xxxxxx时
          if(copyData.indexOf("3.cn/") != -1) {
            // e.target.value = preData.substring(0, preData.length - 6)
            this.$message.error("请勿复制或者重复使用短链接")
          }
        }, 10)
      }, 100);
    },

    // 敏感词检测
    Vue.prototype.$wordCheck = async function(params) {
      return new Promise((resolve, reject) => {
        checkWord(params).then((result) => {
          resolve(result)
        }).catch((err) => {
          reject(err)
        });
      })
    }

    // 数字每3位加 ，
    Vue.prototype.$changeThreeNum = function(number) {
      if (!number) {
        return number;
      }
      const str = String(number)
      if (str.length && str.indexOf('.') != -1) {
          let num = Number(str)
          if (!num) num = 0
          num = num.toFixed(2)
          let c = num.split('.')
          let b = c[0].toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + c[1]
          return b
      } else {
          const reg = /(\d)(?=(?:\d{3})+$)/g;
          const newNumber = number.toString().replace(reg, "$1,");
          return newNumber;
      }
    }


    /**
     * 2个形参必传，target元素必须设置全局类名text-indent-box
     * source: 来源id，根据该id的宽度设置当前文本框首行缩进的距离
     * target：目标id，根据该id设置的目标文本框的首行缩进的距离
    */
    Vue.prototype.$changeRootIndent = function(source, target) {
      setTimeout(() => {
        const sourceDom = document.getElementById(source)
        const targetDom = document.getElementById(target)
        targetDom.style.setProperty('--text-indent', `${sourceDom.offsetWidth + 6}px`)
      }, 500)
    }

    // #付款链接# #评价链接# 由实际字数转为 15 个字
    Vue.prototype.$linkConvertNum = function(content) {
      const str = content.replace(/#付款链接#/g, "###############").replace(/#评价链接#/g, "###############")
      return str.length
    }

    // type: 1：传值 0：传input实例
    // e: 值或者input实例
    // decimal: 1表示允许小数点 0表示整数, 
    // min：允许传入最小值，小于这个值时返回""
    Vue.prototype.getNumberData = function(type, e, decimal = 0, min = 1, max = -1) {
      let str = ""
      if(type) {
        str = String(e)
      } else {
        str = String(e.target.value)
      }
      
      let num = decimal ? str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') : str.replace(/[^\d]/g, '')
      if (num < min) {
        num = "";
      }
      if (max != -1 && max < num) {
        num = max;
      }
      return num
    }
    // 判断一个时间是否大于指定时间
    Vue.prototype.isCurrentTimeAfter = function(targeDateStr,dateStr = "2024-11-12 23:59:59") {
      var now = new Date(dateStr);
      var targetDate = new Date(targeDateStr);
      return targetDate > now ;
    }
    /**
     *  限制输入数字可选保留两位小数限制最大值
     */
    Vue.prototype.getLimit = function(str,type,maxNum,minNum=0,hasMax=true) {
      if(str[0]==".") {
          str = ""
      }
      if(str[0]=='0'&&str.length>1&&str.indexOf(".")==-1) {
          str = '0'
      } 
      str = type==1 ? str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1').replace(/[^\d.]/g, "") : str.replace(/[^\d]/g, "")
      if(Number(str)>maxNum&&hasMax) {
          str = maxNum + ''
      }
      if(Number(str)<minNum || str == "0.00") {
          str = ''
      }
      return str
    }
    // 添加奖品类型判断方法
    Vue.prototype.getPrizeTypeName = function(value) {
      const venderType = this.$store.getters.loginUserInfo.venderType;
      const obj = prizeTypeList.find(item => item.value == value);
      if(obj) {
        if(obj.value == 13){
          return '令牌'
        } else if(venderType && obj.value == 12) {
          return '令牌'
        } else if(!venderType && obj.value == 12){
          return '专享价'
        } else {
          return obj.label;
        }
      } else {
        return '-'
      }
    };
    // 添加活动类型判断方法
    Vue.prototype.getActivityTypeName = function(value) {
      const obj = activityTypeList.find(item => item.value == value);
      if(obj) {
        return obj.label;
      } else {
        return ''
      }
    };
    Vue.prototype.getCommonText = function(levelList,ruleForm,ruleDTO,actMember,isShowActName=true,isShowCcondText=false,isShowOldCus=false) {
      let actName = "", actTime = "",actObj = "",text= "",actCond = "",precautions="",textObj="一、【活动时间与对象】";
      if (isShowActName&&ruleForm.activityName && ruleForm.activityName.length > 0) {
        actName = "活动名称：" + ruleForm.activityName;
      }
      if (ruleForm.startTime && ruleForm.endTime) {
        actTime =
          "活动时间：" + ruleForm.startTime + "-" + ruleForm.endTime;
      }
      // 活动参与对象
      let isIdentity = false;
    
      if(actMember == 2) {
        console.log(ruleForm,ruleDTO,'hhffgfgf');
        if(ruleForm.partner.length==1&&ruleForm.partner.findIndex(item=>item==-1)>-1&&ruleForm.firstOpenCardTimeType==0&&ruleDTO.plusObject==0&&!ruleForm.orderCompleteLimitCount&&!ruleForm.orderCompleteMaxCount&&!ruleForm.orderCompleteLimitPayment&&!ruleForm.orderCompleteMaxPayment&&!ruleForm.lastOrderCompleteTimeType) {
          if(isShowOldCus) {
            if(ruleForm.ruleDTO&&ruleForm.ruleDTO.cusType) {
              isIdentity = false;
            } else {
              isIdentity = true;
            }
          }  else {
            isIdentity = true;
          }
        }
      }
      if (actMember == 1||isIdentity) {
        actObj = "活动对象：" + "不限";
      } else if (actMember == 2) {
        // 会员等级
        let levelText = [];
        // 入会时间
        let membership = ""
          // 购物条件
        let condText = ""
        if (ruleForm.partner.length > 0) {
          ruleForm.partner.forEach((item, index) => {
            if (item == -1) {
              item = "不限";
            } else if (item == 0) {
              item = "非会员";
            } else {
              levelList.forEach((it, index) => {
                if (index + 1 == item) {
                  item = it;
                }
              });
            }
            levelText.push(item);
          });
        }
        if(ruleForm.firstOpenCardTimeType==0) {
          membership = "不限"
        } else if(ruleForm.firstOpenCardTimeType==1&&ruleForm.openCardBeforeDay) {
          membership = `仅限参与活动前${ruleForm.openCardBeforeDay}天入会的会员参与`
        } else {
          membership = `仅限指定${ruleDTO.openCardStartTime}-${ruleDTO.openCardEndTime}时间范围入会的会员参与`
        }
        // Plus会员身份
        if (ruleDTO.plusObject != 0) {
          text = ruleDTO.plusObject == 1 ? "Plus会员" : "非Plus会员";
        } else {
          text = `不限`;
        }
        if(isShowCcondText) {
          if(!ruleForm.orderCompleteLimitCount&&!ruleForm.orderCompleteMaxCount&&!ruleForm.orderCompleteLimitPayment&&!ruleForm.orderCompleteMaxPayment&&ruleForm.lastOrderCompleteTimeType==0) {
            condText = "不限"
          } else {
            let condParts = [];
            
            // 处理订单笔数条件
              if(ruleForm.orderCompleteLimitCount && ruleForm.orderCompleteMaxCount) {
                let countText = `累计完成订单笔数：${ruleForm.orderCompleteLimitCount}笔至${ruleForm.orderCompleteMaxCount}笔`;
                condParts.push(countText);
              }
            
            // 处理订单金额条件
            if(ruleForm.orderCompleteLimitPayment && ruleForm.orderCompleteMaxPayment) {
              let paymentText = `累计完成订单金额：${ruleForm.orderCompleteLimitPayment}元至${ruleForm.orderCompleteMaxPayment}元`;
              condParts.push(paymentText);
            }

            
            // 处理最后一次订单完成时间条件
            let timeText = "最后一次订单完成时间：";
            if(ruleForm.lastOrderCompleteTimeType!=0) {
              
              if(ruleForm.lastOrderCompleteTimeType==1) {
                if(ruleForm.lastOrderCompleteStartDay&& ruleForm.lastOrderCompleteEndDay) {
                  timeText += `距当前${ruleForm.lastOrderCompleteStartDay}天至${ruleForm.lastOrderCompleteEndDay}天`;
                }
              } else if(ruleForm.lastOrderCompleteTimeType===2) {
                if(ruleForm.lastOrderCompleteStartTime&&ruleForm.lastOrderCompleteEndTime) {
                  timeText += `指定${ruleForm.lastOrderCompleteStartTime}至${ruleForm.lastOrderCompleteEndTime}期间`;
                }
              }
              if(timeText != "最后一次订单完成时间：") {
                condParts.push(timeText);
              }
            } else {
              timeText += "不限"
              condParts.push(timeText);
            }
            
            if(condParts.length > 0) {
              condText = `仅限指定购物条件的老客参与（${condParts.join("，且")}）`;
            } else {
              condText = "不限";
            }
          }
        }
        // 新老客户
        let customer = ""
        if(isShowOldCus) {
          customer = "新老客户：" + 
          (ruleForm.ruleDTO.cusType==0?'不限':'') + 
          (ruleForm.ruleDTO.cusType==1?'历史新客':'') +
          (ruleForm.ruleDTO.cusType==2?'近365天新客':'') + 
          (ruleForm.ruleDTO.cusType==3?'老客':'')
        }
        let obj1 = "会员等级：" + levelText.join("、");
        let obj2 = "首次入会时间：" + membership;
        let obj3 = "Plus会员身份：" + text;
        let obj4 = "指定购物条件：" + condText;
        let arr = [obj1,obj2,obj3]
        actObj = "活动对象：仅限指定身份可参与\n";
        if(isShowOldCus) {
          arr.unshift(customer)
        }
        if(isShowCcondText) {
          arr.push(obj4)
        }
        arr.forEach((item,index)=>{
          actObj += `（${index+1}）${item}`
          if(index!=arr.length-1) {
            actObj += "\n"
          }
        })
      } else if (actMember == 3) {
        actObj = "活动对象：" + "指定人群";
      }
      // 活动条件
      if (ruleForm.condFollow && ruleForm.openCardFollow == 0) {
        actCond = "活动条件：关注店铺后方可参加活动";
      }
      if (!ruleForm.condFollow && ruleForm.openCardFollow == 1) {
        actCond = "活动条件：开卡入会后方可参与活动";
      }
      if (ruleForm.condFollow && ruleForm.openCardFollow == 1) {
        actCond = "活动条件：关注店铺，且开卡入会后方可参与";
      }
      precautions = "客户信息收集：页面弹屏提示中奖客户提供收货地址、号码和奖项；(请及时填写，方便奖品发放);实物奖品采取寄送方式发放，获得中奖资格的用户根据填写的姓名、联系电话、详细地址信息发放。如因用户原因无法联系上，即奖品作废不再补发，或如用户未填写真实有效的信息或填写收货信息不详，均视为放弃奖品;\n2.活动参与主体资格：\n（1）同一用户仅限参与活动一次。同一用户是指账户、手机号码、收件地址、支付账号、身份证号码、设备标识符、注册信息、网络操作日志、交易订单信息等与用户身份和行为相关的信息，其中任意一项或数项存在相同、相似，亦或通过特定标记批量信息进行分析，其数项存在相同、相似的（包括但不限于批量相同、雷同、邻近、虚构的地址）均视为同一用户。同一用户注册、持有、使用或控制多个会员账号，商家有权取消/限制其参与本活动或领取奖品的资格；\n" + 
      "（2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格;\n3.注意事项：\n（1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利;\n（2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动\n（3）本活动所发放的实物奖、虚拟奖品均不得提现、不得转赠他人、不得为他人付款;\n（4）是否获得中奖资格以活动发布者后台统计结果为准;\n（5）实物奖品一经发出，无质量问题恕不退换，如有疑问，请咨询客服。\n"+ 
      "（6）商家可根据活动的实际进行情况，在法律允许的范围内，对本活动规则进行调整或变动，相关调整或变动将公布在活动规则页上。\n（7）如对本活动有任何疑问，请咨询客服。\n"
      let firstText = [textObj,actName,actTime, actObj, actCond]
      let firstTextStr = "";
      let newNum = 0;
      firstText.forEach((row, it) => {
        if (row.length > 0) {
          if (it != 0) {
            firstTextStr = firstTextStr + newNum + "." + row + "\n";
          } else {
            firstTextStr = firstTextStr + row + "\n";
          }
          newNum = newNum+ 1;
        }
      });
      return {actName,actTime,actObj,actCond,precautions,firstText,firstTextStr}
    }
    // 实物随单发
    Vue.prototype.getPhysicalShipped = function(obj,prizeType,data) {
      if(prizeType == 14) {
        if (!data.isGoodManage) {
          obj.skuId = data.skuId;
          delete obj.isGoodManage;
        } else {
          obj.isGoodManage = data.isGoodManage;
        }
        obj.pointActivityPrizeRemark = data.pointActivityPrizeRemark;
      } else if(prizeType == 1) {
        obj.prizeGoShop = data.prizeGoShop
      }
      return obj;
   }
  }
}